// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-3300fe62] .md-dialog{width:900px}", "",{"version":3,"sources":["webpack://./src/components/SamplesTraceability/ViewBatchRouteModal.vue"],"names":[],"mappings":"AACA,6BACE,WAAA","sourcesContent":["\n:deep(.md-dialog) {\n  width: 900px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
